import React, { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Container, Grow, Grid } from '@material-ui/core'

import FormAddColorMixing from '../Form/FormAddColorMixing'

// import { API_URL, URL } from '../../constants/actionTypes'
const AddColorMixing = () => {
  // const navigate = useNavigate()
  // const loginSuccess = JSON.parse(localStorage.getItem('colorMixing'))
  useEffect(() => {
    // if (!loginSuccess) {
    //   navigate(URL + '/login')
    // }
  }, [])
  return (
    <Grow in>
      <Container className='pageInstructors'>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12} sm={12}>
            <FormAddColorMixing />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default AddColorMixing
